<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB DETAILS
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <p class="new-title">Job Reference No.</p>
              <p class="subtitle">{{ jobno }}</p>

              <p class="new-title">Collection Date</p>
              <p class="subtitle">{{ collectiondate }}</p>

              <p class="new-title">Service Location</p>
              <p class="subtitle">{{ servicelocation }}</p>

              <p class="new-title">Service Location Collection</p>
              <p class="subtitle">{{ servicelocationcollection }}</p>

              <p class="new-title">Company Name</p>
              <p class="subtitle">{{ companyName }}</p>

              <p class="new-title">Company Address</p>
              <p class="subtitle">{{ companyAddress }}</p>

              <p class="new-title">Phone No. / Fax No.</p>
              <p class="subtitle">{{ phoneNoFaxNo }}</p>

              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">{{ picFullName }}</p>

              <p class="new-title">PIC Phone No. / Fax No.</p>
              <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">{{ picEmail }}</p>
            </div>
          </card>
          <!-- <card
            style="box-shadow: none;
              color: #A5A5A5;
              padding: 0px 0px 30px 30px;
              height: 630px;
              background-color: white;
            "
          >
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              NPV2110280002
            </p>

            <p class="new-title">Customer</p>
            <p class="subtitle">
              Ombak Biru Holdings 202, Jalan Port Klang Pelabuhan, 42005
              Selangor, Malaysia
            </p>

            <p class="new-title">Due Date</p>
            <p class="subtitle">21 Nov 2022</p>

            <p class="new-title">Job Created Date</p>
            <p class="subtitle">15 Nov 2022</p>

            <p class="new-title">Person in Charge (PIC)</p>
            <p class="subtitle">Amirah binti Azman</p>

            <p class="new-title">PIC Tel. No.</p>
            <p class="subtitle">+60 19 562 7890</p>

            <p class="new-title">Ship Name</p>
            <p class="subtitle">Eagle 01</p>
          </card> -->
        </div>
        <div class="col-lg-4 dlex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              INVOICE
            </p>
            <div style="height: 520px; overflow: auto; overflow-x: hidden">
              <!-- <div class="row">
                <div class="col-lg">Invoice generating date</div>
                <div class="col-lg">: {{ invoicedate }}</div>
              </div>
              <div class="row">
                <div class="col-lg">Invoice generating status</div>
                <div class="col-lg">: {{ invoicestatus }}</div>
              </div>
              <div class="row">
                <div class="col-lg">Invoice sent to email timestamp</div>
                <div class="col-lg">
                  :
                  {{ invoiceemaildate }}
                </div>
              </div>

              <div class="row">
                <div class="col-lg text-left">
                  <base-button class="btn-sm btn-primary" @click="resendemail()" :disabled="!isAllowToSend">Resend
                    Email</base-button>
                </div>
              </div>
              <br /> -->
              <div class="row">
                <div class="col-lg">
                  <p style="color: #A5A5A5; font-weight: bold">Invoice</p>
                  <p style="color: grey" v-if="positionid != 4">
                    Please upload invoice
                  </p>
                  <div class="fileinput" v-if="positionid != 4">
                    <label for="invoice-upload" type="primary" class="btn" style="
                        font-size: 13px;
                        color: #ffffff;
                        text-transform: capitalize;
                      ">
                      Choose File
                    </label>

                    <div class="d-flex justify-content-center spinner" v-if="uploadload == true">
                      <circle-8></circle-8>
                    </div>

                    <input accept="application/pdf" id="invoice-upload" type="file" ref="invoicefile" name="..."
                      class="valid" :multiple="true" aria-invalid="false" style="display: none"
                      v-on:change="onInvoiceChange" />
                  </div>
                  <div style="" class="">
                    <div v-for="(file, index) in allInvoice" :key="index" class="row">
                      <div class="col-lg-8">
                        <a :href="file.url">
                          <base-button class="btn-link btn-primary">
                            {{ file.meta.filename }}
                          </base-button>
                        </a>
                      </div>
                      <div class="col-lg-4">
                        <base-button v-if="positionid != 4" class="btn-sm btn-cancel" style="font-size: 12px"
                          @click="removeFile(file.invoice_document_id)">
                          Remove
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <div class="row">
                <div class="col-lg">
                  <p style="color: #A5A5A5; font-weight: bold">Proof of Payment</p>
                  <p style="color: grey" v-if="positionid != 4">
                    Please upload proof of payment / receipt
                  </p>
                  <div class="fileinput" v-if="positionid != 4">
                    <label for="prrof-upload" type="primary" class="btn" style="
                        font-size: 13px;
                        color: #ffffff;
                        text-transform: capitalize;
                      ">
                      Choose File
                    </label>

                    <div class="d-flex justify-content-center spinner" v-if="uploadproofofpayment == true">
                      <circle-8></circle-8>
                    </div>

                    <input accept="application/pdf" id="prrof-upload" type="file" ref="proof" name="..." class="valid"
                      :multiple="true" aria-invalid="false" style="display: none" v-on:change="onProofChange" />
                  </div>
                  <div style="
                      padding: 0px 20px 20px 0px;
                      margin: 0px 30px 20px 0px;
                    " class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto">
                    <div v-for="(file, index) in allProof" :key="index" class="row">
                      <div class="col-lg-8">
                        <a :href="file.url">
                          <base-button class="btn-link btn-primary">
                            {{ file.meta.filename }}
                          </base-button>
                        </a>
                      </div>
                      <div class="col-lg-4">
                        <base-button v-if="positionid != 4" class="btn-sm btn-cancel" style="font-size: 12px"
                          @click="removeProof(file.invoice_document_id)">
                          Remove
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button wide type="danger" @click.native="prevTab" class="btn-previous">
            BACK
          </base-button>
          <base-button v-if="positionid != 4" type="primary" wide @click="generateinvoice()" class="btn-next">
            DONE
          </base-button>
          <base-button v-if="positionid == 4" type="primary" wide @click="$router.push('/Incoming')" class="btn-next">
            DONE
          </base-button>
        </div>
      </div>
      <modal :show.sync="modals.done" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>JOB REQUEST COMPLETED</h1>
          </div>
        </div>
      </modal>
      <StatusModal :show.sync="modals.removeModal" :message="modal.remove" :title="modal.removeTitle" />
      <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />
    </div>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  Option,
  Select,
  DatePicker,
  TimePicker,
  TimeSelect,
} from "element-ui";
import moment, { utc } from "moment";
import swal from "sweetalert2";

import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [TimePicker.name]: TimePicker,
    Circle8,
    Modal,
  },
  // props: ["test1"],
  data() {
    return {
      invoicestatus: "",
      invoicedate: "",
      invoiceemaildate: "",
      isAllowToSend: "",
      modal: modal,
      allInvoice: [],
      allProof: [],
      collectiondate: "",
      servicelocation: "",
      servicelocationcollection: "",
      landvesselflag: "",
      jobno: "",
      arrivalETA: "18 Nov 2022",
      departureETD: "15 Nov 2022",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      companyName: "Ombak Biru Holdings",
      companyAddress: "Coplace 2, Switzeeerrrrrss",
      phoneNoFaxNo: "08-98989989",
      picFullName: "Wahab bin Wahab",
      picPhoneNoFaxNo: "012-3569488",
      picEmail: "wahab@sendirianberhad.com",
      shipName: "Tiger Wave",
      imoNo: "8804275",
      shipType: "Ikan bilis tanker",
      grossTonnage: "220000",
      deadweightTonnage: "10000",
      owneroperatorname: "Abu bin Seman",
      callSign: "Bilis dot com",
      flagState: "Malaysia",
      sustainableCertificates: "1 - ISO 14001.pdf",

      modals: {
        done: false,
        successModal: false,
        removeModal: false,
      },
      message: "",

      done: false,
      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      checkedItems: [],

      required: [
        { value: 0, label: "Not required" },
        {
          value: 1,
          label: "Not requigetDetail()red",
        },
      ],
      selectedFileName: "",
      allfilename: [],
      docs: "",
      document: 0,

      documentID: [],
      uploadproofofpayment: false,
      uploadload: false,
      positionid: "",
    };
  },
  created() {
    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getDetail();
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
  },
  mounted() {
    this.done = sessionStorage.getItem("done");
  },
  methods: {
    resendemail() {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, send email!",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result.value);
        if (result.value) {
          this.$http
            .post(
              ":10001/api/v1/incoming/" + this.jobno + "/invoice/resend-email"
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.modal.success = response
                this.modals.successModal = true
              }
            }).catch(err => {
              this.modal.remove = err.response.data.message
              this.modals.removeModal = true
            });
        }

      });
    },
    removeProof(id) {
      this.$http
        .delete(":10001/api/v1/incoming/" + this.jobno + "/proof-of-payment")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.removeModal = true;
            this.getDetail();
          }
        });
    },
    onProofChange(e) {
      this.uploadproofofpayment = true;
      if (this.allProof.length < 1) {
        let data = this.$refs.proof.files[0];

        const formData = new FormData();
        formData.append("document", data);

        // to verify form data
        for (var pair of formData.entries()) {
          console.log(pair);
        }

        this.$http
          .post(
            ":10001/api/v1/incoming/" + this.jobno + "/proof-of-payment",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              this.message = response;
              this.modals.successModal = true;
              this.uploadproofofpayment = false;
              // swal({
              //   title: `Success!`,
              //   text: response,
              //   buttonsStyling: false,
              //   confirmButtonClass: "btn btn-primary btn-fill",
              //   type: "success",
              // });
              this.getDetail();
            }
          });
      } else {
        swal({
          title: `Info!`,
          text: "Only 1 file allowed to be uploaded",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "info",
        });
        this.uploadproofofpayment = false;
      }
      e.target.value = ''
    },
    onInvoiceChange(e) {
      this.uploadload = true;
      if (this.allInvoice.length < 1) {
        let data = this.$refs.invoicefile.files[0];

        const formData = new FormData();
        formData.append("document", data);

        // to verify form data
        for (var pair of formData.entries()) {
          console.log(pair);
        }

        this.$http
          .post(
            ":10001/api/v1/incoming/" + this.jobno + "/invoice-upload",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              this.message = response;
              this.modals.successModal = true;
              this.uploadload = false;
              // swal({
              //   title: `Success!`,
              //   text: response,
              //   buttonsStyling: false,
              //   confirmButtonClass: "btn btn-primary btn-fill",
              //   type: "success",
              // });
              this.getDetail();
            }
          });
      } else {
        swal({
          title: `Info!`,
          text: "Only 1 file allowed to be uploaded",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "info",
        });
        this.uploadload = false;
      }
      e.target.value = ''
    },
    getDetail() {
      this.allInvoice = [];
      this.allProof = [];

      this.$http
        .get(":10001/api/v1/incoming/scrap/" + this.jobno)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            // this.landvesselflag = response.company.company_type.toUpperCase();
            if (typeof response.dashboard_step == 'string') {
              this.step = Number(response.dashboard_step)
            } else if (typeof response.dashboard_step == 'number') {
              this.step = response.dashboard_step;
            } else {
              this.step = response.dashboard_step;
            }
            this.collectiondate = moment(response.collection_date).format(
              "YYYY-MM-DD"
            );
            this.servicelocation = response.service_location.service_location;
            this.servicelocationcollection =
              response.service_location.collection_location;
            this.companyName = response.company.company_name;
            this.companyAddress = response.company.company_address;

            this.phoneNoFaxNo =
              (response.company.company_phone_number == "" ||
                response.company.company_phone_number == null
                ? "N/A"
                : response.company.company_phone_number) +
              " / " +
              (response.company.company_fax_number == "" ||
                response.company.company_fax_number == null
                ? "N/A"
                : response.company.company_fax_number);
            this.picFullName = response.pic.pic_name;
            this.picPhoneNoFaxNo =
              (response.pic.pic_phone_number == "" ||
                response.pic.pic_phone_number == null
                ? "N/A"
                : response.pic.pic_phone_number) +
              " / " +
              (response.pic.pic_fax_number == "" ||
                response.pic.pic_fax_number == null
                ? "N/A"
                : response.pic.pic_fax_number);

            this.picEmail = response.pic.pic_email;

            // for (var i = 0; i < response.waste_details.length; i++) {
            //   let obj = {
            //     no: i + 1,
            //     wastetype:
            //       response.waste_details[i].waste_type_name == ""
            //         ? "N/A"
            //         : response.waste_details[i].waste_type_name,
            //     packagingtype:
            //       response.waste_details[i].packaging_type_name == ""
            //         ? "N/A"
            //         : response.waste_details[i].packaging_type_name,
            //     wasteorigin: response.waste_details[i].waste_origin,
            //     wastecomponent: response.waste_details[i].waste_components,
            //     estqty: response.waste_details[i].estimated_quantity,
            //     estqtyunit: response.waste_details[i].estimated_quantity_unit,
            //     packagingqty: response.waste_details[i].packaging_quantity,
            //     packagingqtyunit: response.waste_details[i].packaging_type_name,
            //     remarks: response.waste_details[i].remark,
            //     image: response.waste_details[i].images,
            //   };

            //   this.wastedetails.push(obj);
            // }

            // get lab report
            if (response.invoice_document != null) {
              this.allInvoice.push(response.invoice_document);
            }

            if (response.proof_of_payment != null) {
              this.allProof.push(response.proof_of_payment);
            }

            this.invoicestatus =
              response.invoice_status == 1 ? "Completed" : "Pending";
            this.invoicedate =
              response.invoice_date == ""
                ? "-"
                : moment(response.invoice_date).format("YYYY-MM-DD hh:mm a");
            this.invoiceemaildate =
              response.invoice_email_send_at == ""
                ? "-"
                : moment(response.invoice_email_send_at).format(
                  "YYYY-MM-DD hh:mm a"
                );
            this.isAllowToSend = response.can_send_invoice_email;
          }
        });
    },
    generateinvoice() {
      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/complete")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.$router.push("/incoming");
          }
        });
      // this.$http.post(":10001/api/v1/incoming/"+this.jobno+"/complete").
      // then(res => {
      //   if(!res.error){
      //     let response = res.message
      //     console.log(response)
      //     this.modals.done = true;
      //     setTimeout(() => {
      //       this.$router.push("/Incoming");
      //     }, 1000);
      //   }
      // })
    },
    prevTab() {
      let parameter = {
        step: "6",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    onFileChange(event) {
      const t = event.target;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          this.selectedFileName = t.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
      } else {
        this.selectedFileName = "";
      }

      this.document = t.files.length;

      var input;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);
          this.docs = formData;

          this.uploadload = true;

          this.$http
            .post(":10001/api/v1/upload/company_support_document", this.docs, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                this.documentID.push(response.document_id);
              } else {
              }

              this.uploadload = false;
            });
        }
      }
    },
    removeFile(id) {
      this.$http
        .delete(":10001/api/v1/incoming/" + this.jobno + "/invoice-upload")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.removeModal = true;
            this.getDetail();
          }
        });
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
  watch: {},
};
</script>
<style scoped>
.textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

.textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  margin-top: -5px;
  color: #A5A5A5;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}
</style>
